export default "__VITE_PUBLIC_ASSET__ea118bbc__"